<script setup>
  const { percentage } = defineProps(['percentage']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <div class="diagram" :style="{ '--percentage': percentage }"><slot /></div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .stat {
    h5 {
      font-size: px(48);
    }

    .diagram {
      $thickness: px(11);
      position: relative;

      width: px(226);
      aspect-ratio: 1;

      display: flex;
      align-items: center;
      justify-content: center;

      &:before {
        content: '';
        position: absolute;
        border-radius: 50%;
        inset: 0;

        background: $black-5;

        -webkit-mask: radial-gradient(
          farthest-side,
          transparent calc(99% - $thickness),
          $black calc(100% - $thickness)
        );
        mask: radial-gradient(farthest-side, transparent calc(99% - $thickness), $black calc(100% - $thickness));
      }

      &:after {
        content: '';
        position: absolute;
        border-radius: 50%;
        inset: 0;
        background: conic-gradient($red calc(var(--percentage) * 1%), transparent 0);
        -webkit-mask: radial-gradient(
          farthest-side,
          transparent calc(99% - $thickness),
          $black calc(100% - $thickness)
        );
        mask: radial-gradient(farthest-side, transparent calc(99% - $thickness), $black calc(100% - $thickness));
      }
    }
  }
</style>
